/* Mobile menu burger toggle */
(function () {
  var burger = document.querySelector('.gh-burger');

  if (!burger) return;

  burger.addEventListener('click', function (e) {
    e.preventDefault();

    document.body.classList.toggle('is-head-open');
  });
})();

/* Add lightbox to gallery images */
(function () {
  lightbox(
    '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
  );
})();

/* Responsive video in post content */
(function () {
  const sources = [
    '.gh-content iframe[src*="youtube.com"]',
    '.gh-content iframe[src*="youtube-nocookie.com"]',
    '.gh-content iframe[src*="player.vimeo.com"]',
    '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
    '.gh-content object',
    '.gh-content embed',
  ];

  reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
  dropdown();
})();

(function () {
  pagination(true);
})();

(function () {
  if (document.querySelector('.gh-currency-page')) {
    exchangeInit();
  }

  if (document.querySelector('.gh-weather-page')) {
    weatherInit();
  }

  if (document.querySelector('.currency-feed')) {
    infoInit();
  }
})();

(function () {
  if (!document.body.classList.contains("post-template")) return;

  const cover = document.querySelector(".gh-cover");
  if (!cover) return;

  const image = cover.querySelector(".gh-cover-image");

  window.addEventListener("load", function () {
    cover.style.setProperty(
      "--cover-height",
      (image.clientWidth * image.naturalHeight) / image.naturalWidth + "px"
    );
    cover.classList.remove("loading");
  });
})();

const shareBtn = document.querySelector(".share-button");
if (shareBtn !== null) {
  shareBtn.addEventListener("click", function (event) {
    try {
      navigator.clipboard.writeText(window.location.href);
    } catch (err) {
      console.log("Oops, unable to copy");
    }

    event.preventDefault();
  });
}

(function () {
  let words = [
      'ziar.md',
    ],
    part = null,
    i = 0,
    offset = 0,
    len = words.length,
    forwards = true,
    skip_count = 0,
    skip_delay = 40,
    speed = 300;

  const wordflick = function () {
    setInterval(function () {
      if (forwards) {
        if (offset >= words[i].length) {
          ++skip_count;
          if (skip_count == skip_delay) {
            forwards = false;
            skip_count = 0;
          }
        }
      }
      // else {
      //   if (offset == 0) {
      //     forwards = true;
      //     i++;
      //     offset = 0;
      //     if (i >= len) {
      //       i = 0;
      //     }
      //   }
      // }

      part = words[i].substr(0, offset);
      if (skip_count == 0) {
        if (forwards) {
          offset++;
        }
        // else {
        //   offset = 0;
        // }
      }

      document.querySelector('.gh-head-logo').innerText = part
    }, speed);
  };

  wordflick();
})();
